'use strict';

var base = require('org/product/base');
var quantitySelect = require('org/components/quantitySelect');

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 * @param {boolean} isFloat - Whether to wrap the error in a floating container
 */
function createErrorNotification(message, isFloat = false) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    if (isFloat) {
        $('.add-to-cart-messages').remove();
        $('body').append('<div class="add-to-cart-messages"></div>');
        $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert text-center" role="alert">' + message + '</div>');
        return;
    }

    $('.cart-error').append(errorHtml);
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * appends params to a url
 * @param {DOMElement} triggerElement - the element that initiated the call
 * @returns {Promise} - Promise object represents the result of the ajax call
 */
function displayMessageAndRemoveFromCart(triggerElement) {
    var $targetElement = $(triggerElement);
    var itemToMove = {
        actionUrl: $targetElement.data('action'),
        productID: $targetElement.data('pid'),
        productName: $targetElement.data('name'),
        uuid: $targetElement.data('uuid')
    };

    $('body').trigger('afterRemoveFromCart', itemToMove);

    var productID = itemToMove.productID;
    var url = itemToMove.actionUrl;
    var uuid = itemToMove.uuid;
    var urlParams = {
        pid: productID,
        uuid: uuid
    };

    url = appendToUrl(url, urlParams);

    $('body').trigger('cart:beforeUpdate');

    return $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (response) {
            $('body').trigger('cart:itemRemoved', [response, uuid]);
        },
        error: function (err) {
            if (err.responseJSON && err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else if (err.responseJSON && err.responseJSON.errorMessage) {
                createErrorNotification(err.responseJSON.errorMessage);
                $.spinner().stop();
            } else {
                window.location.reload();
            }
        }
    });
}

/**
 * @param {Object} $elementAppendTo - The element to append error html to
 * @param {string} msg - The error message
 * display error message if remove item from saveforlater failed
 */
function displayErrorMessage($elementAppendTo, msg) {
    const msgContainer = $('<div class="remove-from-saveforlater-messages"></div>');
    $elementAppendTo.append(msgContainer);
    msgContainer.append('<div class="remove-from-saveforlater-alert text-center alert alert-danger">' + msg + '</div>');

    setTimeout(function () {
        msgContainer.remove();
    }, 3000);
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 * @param {string} focusElementSelector - selector of the element to focus on
 */
function renderNewPageOfItems(pageNumber, spinner, focusElementSelector) {
    var publicView = $('.saveforlaterItemCardsData').data('public-view');
    var listUUID = $('.saveforlaterItemCardsData').data('uuid');
    var url = $('.saveforlaterItemCardsData').data('href');
    if (spinner) {
        $.spinner().start();
    }
    var scrollPosition = document.documentElement.scrollTop;
    var newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    }).done(function (data) {
        $('body .saveforlaterItemContainer').empty().append(data);
        $('body .saveforlaterListEmpty').empty();

        if (focusElementSelector) {
            $(focusElementSelector).focus();
        } else {
            document.documentElement.scrollTop = scrollPosition;
        }
        $.spinner().stop();
    }).fail(function () {
        $('.more-sl-items').remove();
        $.spinner().stop();
    });
}

/**
 * delete the item from saveforlater list when adding to cart
 * @param {string} deleteUrl - selector of the element to focus on
 * @param {string} id - selector of the element to focus on
 * @returns {Promise} - Promise object represents the result of the ajax call
 */
function deleteFromSaveforlater(deleteUrl, id) {
    const saveForLaterContainer = $('.saveforlaterItemContainer');
    saveForLaterContainer.spinner().start();
    return $.ajax({
        url: deleteUrl,
        type: 'get',
        dataType: 'json',
        success: function () {
            $('body').trigger('saveforlater:reload');
            $('.uuid-' + id).remove();
        },
        error: function () {
            var $elToAppendSL = $('.save-for-later-feedback');
            var msg = $elToAppendSL.data('error-msg');
            displayErrorMessage($elToAppendSL, msg);
        }
    }).always(() => saveForLaterContainer.spinner().stop());
}

module.exports = {
    moveToSaveForLater: function () {
        $('body').on('click', '.product-move .move-save-for-later', function (e) {
            var url = $(this).data('url');
            var pid = $(this).data('pid');
            var pliuuid = $(this).data('uuid');
            var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
            var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            var formData = {
                pid: pid,
                pliuuid: pliuuid,
                optionId: optionId,
                optionVal: optionVal
            };

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                data: formData,
                dataType: 'json',
                success: function (data) {
                    if (data.error) {
                        $.spinner().stop();
                        var $elToAppendSL = $('.save-for-later-feedback');
                        displayErrorMessage($elToAppendSL, data.msg);
                    } else {
                        displayMessageAndRemoveFromCart(e.target).then(() => {
                            if ($('.product-cart-item li').length) {
                                if (Object.keys(data.digitize).length !== 0 && $('.product-cart-item li.pid-' + data.digitize.parentPid).length) {
                                    $(data.digitize.html).insertAfter('.product-cart-item li.pid-' + data.digitize.parentPid);
                                }
                                $('body').trigger('saveforlater:reload');
                                return;
                            }
                        });
                    }
                },
                error: function () {
                    displayMessageAndRemoveFromCart(e.target);
                }
            });
        });
    },

    removeFromSaveforlater: function () {
        $('body').on('click', '.remove-from-saveforlater', function () {
            var url = $(this).data('url');
            const saveForLaterContainer = $('.saveforlaterItemContainer');

            saveForLaterContainer.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('body').trigger('saveforlater:reload');
                    if (data.success) {
                        $('.uuid-' + data.uuid).remove();
                    }
                },
                error: function () {
                    var $elToAppendSL = $('.save-for-later-feedback');
                    var msg = $elToAppendSL.data('error-msg');
                    displayErrorMessage($elToAppendSL, msg);
                }
            }).always(() => saveForLaterContainer.spinner().stop());
        });
    },

    addToCartFromSaveforlater: function () {
        $('body').on('click', '.add-to-cart-from-saveforlater', function () {
            var pid;
            var addToCartUrl;
            var pidsQty = 1;

            $.spinner().start();
            $('body').trigger('product:beforeAddToCart', this);

            pid = $(this).data('pid');
            addToCartUrl = $(this).data('url');
            var deleteUrl = $(this).data('action');
            var id = $(this).data('id');
            var wlItem = $(this).data('wl-item');
            var wlList = $(this).data('wl-list');
            var form = {
                pid: pid,
                quantity: pidsQty,
                id: id
            };

            if (wlItem && wlItem.length > 0) {
                form.uaWishlistItemId = wlItem;
            }

            if (wlList && wlList.length > 0) {
                form.uaWishlistId = wlList;
            }

            if ($(this).data('option')) {
                form.options = JSON.stringify($(this).data('option'));
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        if (data.error) {
                            createErrorNotification(data.message, true);
                            $.spinner().stop();
                            return;
                        }
                        $('.minicart').trigger('count:update', data);
                        $('body').trigger('product:afterAddToCart', data);
                        $('body').trigger('saveforlater:promotionSuccess', data);
                        base.miniCartReportingUrl(data.reportingURL, data.error);
                        deleteFromSaveforlater(deleteUrl, id).then(() => {
                            if ($('.cart-empty').length > 0) {
                                location.reload();
                                return;
                            }
                        });

                        const itemData = data.cart.items.find(item => item.UUID === data.pliUUID);

                        const input = $(`input[data-uuid="${itemData.UUID}"]`);

                        if (!input.length) {
                            if (data.lineItemHtml) {
                                $('ul.product-cart-item').append(data.lineItemHtml);
                                quantitySelect.updateTextField($('ul.product-cart-item li').last().find('.quantity-select'));
                            }
                            $('body').trigger('saveforlater:updateCartTotals', data);
                            return;
                        }

                        const newQty = data.quantityTotal && itemData.quantity ? itemData.quantity : 1;

                        input.val(newQty).attr('value', newQty).trigger('change');

                        $('body').trigger('saveforlater:updateCartTotals', data);
                    },
                    error: function (err) {
                        if (err.responseJSON && err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            var errorMsg = (err.responseJSON && err.responseJSON.message) || 'An error occurred while adding the product to cart.';
                            createErrorNotification(errorMsg);
                        }
                    },
                    complete: () => $.spinner().stop()
                });
            }
        });
    },

    moreSLItems: function () {
        $('body').on('click', '.more-sl-items', function () {
            var pageNumber = $('.saveforlaterItemCardsData').data('page-number');
            renderNewPageOfItems(pageNumber, true);
        });
    }
};
